<template>
	<div class="slide-timeline">
		<!--		<TimelineRuler />-->

		<BlockTracks></BlockTracks>
	</div>
</template>

<script>
import TimelineRuler from './TimelineRuler.vue';
import BlockTracks from './BlockTracks.vue';

export default {
	name: 'SlideTimeLine',
	components: { BlockTracks, TimelineRuler }
};
</script>

<style scoped>
.slide-timeline {
	width: 100%;
	height: 100%;
}
</style>
